import React, {Fragment} from "react";

export default function DocumentoFirmatoNonValidoView() {

    return (
        <Fragment>
            <div
                className={"text-center"}
                style={{
                    paddingTop: "2rem",
                }}
            >
                <i
                    className="fas fa-times"
                    style={{
                        color: "red",
                        fontSize: "12rem"
                    }}
                />
                <h1>Non Valido</h1>
                <h6>Il certificato non è stato trovato oppure non è valido</h6>
            </div>
        </Fragment>
    );

}